import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalizationModule } from '@abp/ng.core';
import { DocCustomerProjectHierarchyComponent } from './../../customer-project-hierarchy/customer-project-hierarchy.component';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { CustomerProjectHierarchyDto } from '@digiwall/goliath-documents/proxy';
import { CustomerProjectHierarchyStatusService } from '../customer-project-hierarchy-status.service';

@Component({
  selector: 'document-customer-project-hierarchy-global-view',
  templateUrl: './customer-project-hierarchy-global-view.component.html',
  styles: `
    .container {
      display: flex;
      flex-direction: column;
    }

    .row-item {
      display: flex;
      gap: 20px;
      align-items: flex-start;
      margin-bottom: 10px;
    }

    .row-item > div:nth-child(1),
    .row-item > div:nth-child(2) {
      flex: 0 0 150px;
    }

    .row-item > div:nth-child(3) {
      flex: 1;
    }
  `,
  imports: [CommonModule, DocCustomerProjectHierarchyComponent, LocalizationModule],
})
export class CustomerProjectHierarchyGlobalViewComponent {
  hierarchies: CustomerProjectHierarchyDto[];

  protected readonly hierarchyStatus = inject(CustomerProjectHierarchyStatusService);
  protected readonly modal = inject(NgbActiveModal);
}
